/* tslint:disable */
/* eslint-disable */
/**
 * Api Documentation
 * Api Documentation
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    JsonSiwiPartyInfo,
    JsonSiwiPartyInfoFromJSON,
    JsonSiwiPartyInfoFromJSONTyped,
    JsonSiwiPartyInfoToJSON,
} from './JsonSiwiPartyInfo';

/**
 * 
 * @export
 * @interface ApiResultOfListOfJsonSiwiPartyInfo
 */
export interface ApiResultOfListOfJsonSiwiPartyInfo {
    /**
     * 
     * @type {Array<JsonSiwiPartyInfo>}
     * @memberof ApiResultOfListOfJsonSiwiPartyInfo
     */
    data?: Array<JsonSiwiPartyInfo>;
    /**
     * 
     * @type {string}
     * @memberof ApiResultOfListOfJsonSiwiPartyInfo
     */
    message?: string;
    /**
     * 
     * @type {object}
     * @memberof ApiResultOfListOfJsonSiwiPartyInfo
     */
    messageValues?: object;
    /**
     * 
     * @type {string}
     * @memberof ApiResultOfListOfJsonSiwiPartyInfo
     */
    requestId?: string;
    /**
     * 
     * @type {string}
     * @memberof ApiResultOfListOfJsonSiwiPartyInfo
     */
    result?: ApiResultOfListOfJsonSiwiPartyInfoResultEnum;
}

/**
* @export
* @enum {string}
*/
export enum ApiResultOfListOfJsonSiwiPartyInfoResultEnum {
    Ok = 'OK',
    Error = 'ERROR'
}

export function ApiResultOfListOfJsonSiwiPartyInfoFromJSON(json: any): ApiResultOfListOfJsonSiwiPartyInfo {
    return ApiResultOfListOfJsonSiwiPartyInfoFromJSONTyped(json, false);
}

export function ApiResultOfListOfJsonSiwiPartyInfoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ApiResultOfListOfJsonSiwiPartyInfo {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'data': !exists(json, 'data') ? undefined : ((json['data'] as Array<any>).map(JsonSiwiPartyInfoFromJSON)),
        'message': !exists(json, 'message') ? undefined : json['message'],
        'messageValues': !exists(json, 'messageValues') ? undefined : json['messageValues'],
        'requestId': !exists(json, 'requestId') ? undefined : json['requestId'],
        'result': !exists(json, 'result') ? undefined : json['result'],
    };
}

export function ApiResultOfListOfJsonSiwiPartyInfoToJSON(value?: ApiResultOfListOfJsonSiwiPartyInfo | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'data': value.data === undefined ? undefined : ((value.data as Array<any>).map(JsonSiwiPartyInfoToJSON)),
        'message': value.message,
        'messageValues': value.messageValues,
        'requestId': value.requestId,
        'result': value.result,
    };
}

